"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ApiManager_1 = require("../ApiManager");
var ApiConfig_1 = require("../config/ApiConfig");
/**
 * App과 연동되는 API 리스트
 */
var ApiApp = /** @class */ (function (_super) {
    __extends(ApiApp, _super);
    function ApiApp() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.UPDATE_PUSH_TOKEN = '/app/updatePushToken';
        /**
         * App push 정보 갱신 API
         * @param token
         * @param pushToken : push token
         * @param appVersion
         * @returns
         */
        _this.updatePushToken = function (token, pushToken, appVersion) {
            var data = {
                tokenId: pushToken,
                appVersion: appVersion,
            };
            return ApiConfig_1.Axios.Client({
                header: { token: token },
                method: 'post',
                url: _this.UPDATE_PUSH_TOKEN,
                data: data,
            });
        };
        return _this;
    }
    ApiApp.getInstance = function (initValue) {
        if (!ApiApp.classInstance) {
            this.classInstance = new ApiApp(initValue);
        }
        return this.classInstance;
    };
    return ApiApp;
}(ApiManager_1.ApiManager));
exports.default = ApiApp;
